import { render } from "./BrowseCategories.vue?vue&type=template&id=bb9ac2d0&scoped=true&ts=true"
import script from "./BrowseCategories.vue?vue&type=script&lang=ts"
export * from "./BrowseCategories.vue?vue&type=script&lang=ts"

import "./BrowseCategories.vue?vue&type=style&index=0&id=bb9ac2d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9ac2d0"],['__file',"src/components/product-category-selector/tabs/BrowseCategories.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb9ac2d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb9ac2d0', __exports__)) {
    api.reload('bb9ac2d0', __exports__)
  }
  
  module.hot.accept("./BrowseCategories.vue?vue&type=template&id=bb9ac2d0&scoped=true&ts=true", () => {
    api.rerender('bb9ac2d0', render)
  })

}


export default __exports__